import { render } from "./CollectCate.vue?vue&type=template&id=60c7926e"
import script from "./CollectCate.vue?vue&type=script&lang=js"
export * from "./CollectCate.vue?vue&type=script&lang=js"

import "./CollectCate.vue?vue&type=style&index=0&id=60c7926e&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__